/**
 * @file Case Study Section Media.
 */

/**
 * Case Study Section Media component.
 */
const vCsSectionMedia = () => {
	const csSectionMedia = document.querySelectorAll('.a-cs-section-media');

	if (!csSectionMedia || !csSectionMedia.length) {
		return;
	}

	document.addEventListener('vOverlayOpening', () => {
		[...csSectionMedia].forEach((el) => {
			const float = window.getComputedStyle(el).getPropertyValue('float');

			if ('left' !== float) {
				return;
			}

			const parent = el.parentElement;
			const top    = el.getBoundingClientRect().top - parent.getBoundingClientRect().top;

			el.style.position = 'relative';
			el.style.top      = `${top}px`;
		} );
	} );

	document.addEventListener('vOverlayTransitioning', () => {
		[...csSectionMedia].forEach((el) => {
			el.removeAttribute('style');
		});
	});
};

export default vCsSectionMedia;
